module.exports = __webpack_public_path__ + "static/img/mail-a.c5e66cce.png";